import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { BuiltFor } from "@/components/landing/BuiltFor";
import { WhyExists } from "@/components/landing/WhyExists";
import { ScriptureDivider } from "@/components/landing/ScriptureDivider";
import { Demo } from "@/components/landing/Demo";
import { Features } from "@/components/landing/Features";
import { QuestionGod } from "@/components/landing/QuestionGod";
import { EditorialMarquee } from "@/components/landing/Marquee";
import { Differentiators } from "@/components/landing/Differentiators";
import { Waitlist } from "@/components/landing/Waitlist";
import { Footer } from "@/components/landing/Footer";
import { scrollToWaitlist } from "@/components/landing/Reveal";

const StickyCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const wl = document.getElementById("waitlist");
      const past = window.scrollY > 700;
      const nearForm = wl && wl.getBoundingClientRect().top < window.innerHeight;
      setShow(past && !nearForm);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          onClick={scrollToWaitlist}
          data-testid="sticky-waitlist-btn"
          className="fixed bottom-6 right-6 z-50 rounded-full bg-green px-6 py-4 text-sm font-semibold text-white shadow-2xl hover:bg-green-dark transition-colors duration-300 md:hidden"
        >
          Join the waitlist
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default function Landing() {
  return (
    <main className="relative bg-sage">
      <div className="grain" />
      <Nav />
      <Hero />
      <BuiltFor />
      <WhyExists />
      <ScriptureDivider />
      <Demo />
      <Features />
      <QuestionGod />
      <EditorialMarquee />
      <Differentiators />
      <Waitlist />
      <Footer />
      <StickyCta />
    </main>
  );
}
